import React from 'react';

const NotFound = () => {
    return (
        <div className='text-center'>
            <h1 className='text-danger'>Page NotFound 404</h1>
            <img  className='img-fluid' src="https://images.pexels.com/photos/674483/pexels-photo-674483.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="" />
        </div>
    );
};

export default NotFound;